<template>
  <!-- @vue-skip TODO: 既存の型エラーを解消したら外す -->
  <div>
    <el-button @click="prevStep">
      <Icon name="arrow-left" space="right" />
      戻る
    </el-button>
    <div class="campaign-create-condition web-instanwin-page">
      <Panel>
        <div class="title-container">
          <FormItemLabel label="ページタイトル" required />
          <el-input
            :maxlength="256"
            type="text"
            :value="form.name"
            placeholder="ページタイトル"
            @input="setPageName"
            @blur="change('page_name')"
          />
        </div>
        <div class="title-name-input-error">
          <div class="empty-label"></div>
          <div v-if="isNameTextEmpty" class="title-input-error">テキストを入力してください。</div>
        </div>
      </Panel>
    </div>
    <div class="campaign-create-condition web-instanwin-page">
      <Panel>
        <div class="condition-item">
          <FormItemLabel label="当選ページ" />
        </div>
        <div class="input-container">
          <div class="label mb-x1">
            <span>当選時テキスト</span>
            <span class="badge badge-danger ml-x1">必須</span>
          </div>
          <EditableComponent
            class="web-instantwin-win-textarea"
            :value="form.lotteryText"
            :highlights="highlights"
            placeholder="内容を入力"
            @input="setPageLotteryText"
            @blur="change('page_win_text')"
          />
        </div>
        <div v-if="isPageWinTextEmpty" class="error-container">
          <div class="empty-label"></div>
          <div class="title-input-error">テキストを入力してください。</div>
        </div>
        <div class="error-container">
          <div class="empty-label"></div>
          <div class="title-input-error">
            <MessageConvert isWebInstantwin />
          </div>
        </div>
        <div class="input-container">
          <div class="label mb-x1">
            <span>当選メディア</span>
            <el-tooltip placement="top">
              <div slot="content">
                当選者用に表示するメディアを選択できます。<br />
                未設定の場合、デフォルトのGIF動画が表示されます。
              </div>
              <i class="mdi mdi-help-circle"></i>
            </el-tooltip>
          </div>
          <div
            class="web-instanwin-page-media"
            v-loading="isUploadMediaLoading"
            element-loading-text="画像/動画をアップロードしています。 しばらくお待ちください。"
          >
            <el-button v-if="!form.mediaUrl" type="primary" @click="$refs.winMediaRef.click()">
              アップロード
            </el-button>
            <div v-if="form.mediaUrl">
              <div class="media-preview">
                <i class="mdi mdi-close" @click="removeMedia"></i>
                <div class="media-name">{{ form.mediaOriginName }}</div>
                <img v-if="isMedia && !form.mediaType" :src="form.mediaUrl" class="direct-media mt-x1" />
                <video
                  v-else-if="isMedia && form.mediaType"
                  :src="form.mediaUrl"
                  class="direct-media mt-x2"
                  controls
                ></video>
              </div>
              <div class="mt-x2">
                <label class="el-button el-button--default" @click="$refs.winMediaRef.click()">
                  <i class="mdi mdi-image"></i>
                  <span v-if="form.mediaUrl">画像/動画を変更</span>
                </label>
              </div>
            </div>
            <span class="media-limit-text">アップロード可能最大サイズ: 画像5MB 動画25MB</span>
            <input
              type="file"
              style="display: none"
              @change="handleFileChange($event)"
              accept="video/mp4,image/jpeg,image/png,image/pjpeg,image/gif"
              ref="winMediaRef"
            />
          </div>
        </div>
      </Panel>
    </div>
    <div class="create-web-instanwin-page">
      <el-button type="primary" native-type="submit" :disabled="isCreateWinPageDisabled" @click="updateWinPage">
        <i class="mdi mdi-content-save" />
        保存
      </el-button>
    </div>
  </div>
</template>
<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import EditableComponent from '@/client/components/_atoms/editable/editable.vue'
import Icon from '@/client/components/_atoms/Icon.vue'
import MessageConvert from '@/client/components/_atoms/message_convert'
import Pagination from '@/client/components/_atoms/pagination'
import Panel from '@/client/components/_atoms/Panel.vue'
import FormItemLabel from '@/client/components/_molecules/FormItemLabel.vue'
import api from '@/client/core/api'
import TwitterUpload from '@/client/core/twitter_upload'
import { TrackingService } from '@/client/services'
import { useLotteryPageSettingDialogStore } from '@/client/store/useLotteryPageSettingDialogStore'
import { WEB_INSTANTWIN_MEDIA_WIN_ORIGIN_NAME, WEB_INSTANTWIN_MEDIA_WIN_URL } from '@/common/constants'

export default defineComponent({
  name: 'LotteryPageWin',
  components: {
    Pagination,
    MessageConvert,
    Icon,
    Panel,
    FormItemLabel,
    EditableComponent
  },
  data() {
    return {
      isUploadMediaLoading: false,
      isMedia: true,
      isChangePageWinText: false,
      isChangePageName: false,
      highlights: [
        {
          type: 'info',
          keywords: ['_account_name_', '_screen_name_', '_account_id_', '_serial_code_']
        }
      ]
    }
  },
  computed: {
    ...mapState(useLotteryPageSettingDialogStore, ['form']),
    isNameTextEmpty(): boolean {
      return this.isChangePageName && !this.form.name.trim()
    },
    isPageWinTextEmpty(): boolean {
      return this.isChangePageWinText && !this.form.lotteryText.trim()
    },
    isCreateWinPageDisabled(): boolean {
      return !this.form.lotteryText || !this.form.name || this.isNameTextEmpty || this.isPageWinTextEmpty
    }
  },

  methods: {
    ...mapActions(useLotteryPageSettingDialogStore, ['setForm', 'reset', 'setMode', 'fetchLotteryPages']),

    /**
     * ファイルを変更
     */
    async handleFileChange(e: any) {
      TrackingService.sendEvent('click:当落選ページの管理|当選ページの作成|アップロード')

      if (!e.target.files || !e.target.files[0]) {
        return
      }

      this.isUploadMediaLoading = true

      const validFormat = ['video/mp4', 'image/jpeg', 'image/png', 'image/gif', 'image/pjpeg', 'image/gif']

      const file = e.target.files[0]

      const checkValidMedia = await TwitterUpload.checkValidMedia(file, validFormat)

      if (checkValidMedia.error) {
        const error = checkValidMedia.error

        switch (error) {
          case 'INVALID_MEDIA':
            this.notify('Please upload valid format!', validFormat.join(', '))
            break
          case 'MAX_SIZE_VIDEO':
            this.notify('25MB以上のビデオを利用することはできません。 サイズを調整してからアップロードしてください。')
            break
          case 'MAX_SIZE_IMAGE':
            this.notify('5MB以上の画像を利用することはできません。サイズを調整してからアップロードしてください。')
            break
          case 'INVALID_DIMENSION':
            this.notify(
              '画像・動画アップロードに失敗しました。',
              '詳しくは<a target="_blank" href="https://help-atelu.comnico.jp/available-image-and-video">こちら</a>をご確認ください。'
            )
            break
        }

        this.isMedia = false
        this.isUploadMediaLoading = false

        return
      }

      const formData = new FormData()
      formData.append('file', file)

      const data = await api.post('/media_uploads', formData, {
        headers: {
          'Content-Type': undefined
        }
      })

      this.isMedia = true

      const mediaType = file.type === 'video/mp4' ? 1 : 0

      this.setForm({
        ...this.form,
        mediaUrl: data.data.media_url,
        mediaOriginName: file.name,
        mediaType
      })

      this.isUploadMediaLoading = false
    },

    /**
     * メディアファイル削除
     */
    async removeMedia() {
      this.isMedia = false

      const removeData = {
        ...this.form,
        mediaUrl: null,
        mediaOriginName: null,
        mediaType: 0 as const
      }

      await this.setForm(removeData)
    },

    /**
     * タイトルを設定
     */
    async setPageName(value: string) {
      TrackingService.sendEvent('input:当選ページの作成||当選時テキスト')
      await this.setForm({ ...this.form, name: value })
      this.change('page_name')
    },
    /**
     * ページ当選時テキストを設定
     */
    async setPageLotteryText(value: string) {
      TrackingService.sendEvent('input:当選ページの作成||当選時テキスト')
      this.change('page_win_text')
      await this.setForm({ ...this.form, lotteryText: value })
    },

    /**
     * テキストを変更チェック
     */
    async change(key: string) {
      switch (key) {
        case 'page_win_text':
          this.isChangePageWinText = true
          break
        case 'page_name':
          this.isChangePageName = true
          break
        default:
          break
      }
    },

    /**
     * ページタイトルを設定
     */
    async prevStep() {
      this.setMode('settings')
    },

    /**
     * エラーを表示
     */
    notify(title: string, message?: any, customClass = 'danger') {
      this.$notify({
        title,
        message,
        customClass,
        dangerouslyUseHTMLString: true,
        duration: 5000
      })
    },

    /**
     * ページを作成
     */
    async updateWinPage() {
      TrackingService.sendEvent('click:当選ページの作成|作成')

      if (this.isCreateWinPageDisabled) {
        return
      }

      const body = {
        campaignId: this.form.campaignId,
        mediaUrl: this.form.mediaUrl || WEB_INSTANTWIN_MEDIA_WIN_URL,
        mediaOriginName: this.form.mediaOriginName || WEB_INSTANTWIN_MEDIA_WIN_ORIGIN_NAME,
        name: this.form.name,
        lotteryText: this.form.lotteryText,
        mediaType: this.form.mediaType
      }

      const response = await api.put(`/twitter_lottery_pages/${this.form.twWebInstantwinLotteryPageSettingId}`, body)

      if (!response || !response.data) {
        this.notify('当選ページの保存に失敗しました。', '恐れ入りますが、時間をおいて再度お試しください。')
        return
      }

      this.notify('当選ページを保存しました。', null, 'success')
      this.fetchLotteryPages()
    }
  }
})
</script>
<style lang="scss" scoped>
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.condition-item .label {
  margin-bottom: $spacing-unit;
}

.title-container {
  display: flex;
  flex-direction: column;
  gap: $spacing-unit;
}

.campaign-create-condition {
  margin-top: $spacing-unit * 2;
}

.web-instanwin-page .input-container {
  display: flex;
  margin-top: $spacing-unit * 2;
}

.web-instanwin-page .label {
  width: 40%;
}

.create-web-instanwin-page {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: $spacing-unit * 2;
}

.media-limit-text {
  display: block;
  margin-top: $spacing-unit;
}

.media-preview {
  position: relative;
  display: inline-block;
  padding: math.div($spacing-unit, 2) $spacing-unit;
  border: 1px solid $border-color;
  border-radius: $round;

  .media-name {
    padding-right: $spacing-unit * 3;
  }

  .mdi {
    position: absolute;
    top: math.div($spacing-unit, 2);
    right: math.div($spacing-unit, 2);
    cursor: pointer;
  }
}

.web-instanwin-page-media {
  width: 100%;
}

.direct-media {
  max-width: 100%;
  max-height: $spacing-unit * 32;
}

.title-name-input-error {
  color: $danger-color;
}

.title-input-error {
  flex: 76%;
  margin-top: $spacing-unit;
  color: $danger-color;
}

.error-container {
  display: flex;
}

.empty-label {
  flex: 30%;
}

.mdi-help-circle {
  margin-left: $spacing-unit;
  font-size: 18px;
}

.web-instantwin-win-textarea {
  width: 100%;
  height: 100%;
}
</style>
